import { Instagram } from "lucide-react";

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer
      data-testid="footer"
      className="relative bg-black border-t border-white/10 py-16 px-6 md:px-12"
    >
      <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-12 gap-10">
        <div className="md:col-span-5">
          <div className="flex flex-col leading-tight">
            <span className="font-display text-3xl md:text-4xl tracking-[0.05em]">AYMES</span>
            <span className="text-[10px] md:text-xs text-[#CCFF00] uppercase tracking-[0.3em] mt-1">
              GK Coaching
            </span>
          </div>
          <p className="mt-6 text-zinc-400 text-sm leading-relaxed max-w-md">
            Coaching individuel pour gardiens de but par Jérémy Aymes, ancien
            professionnel National & Ligue 2. Basé à Martigues — France.
          </p>
        </div>

        <div className="md:col-span-3">
          <p className="text-[10px] uppercase tracking-[0.25em] text-zinc-500 mb-4">
            Navigation
          </p>
          <ul className="space-y-2 text-sm">
            {[
              { l: "À propos", h: "#about" },
              { l: "Services", h: "#services" },
              { l: "Tarifs", h: "#pricing" },
              { l: "Réserver", h: "#booking" },
              { l: "Contact", h: "#contact" },
            ].map((i) => (
              <li key={i.h}>
                <a
                  href={i.h}
                  className="text-zinc-400 hover:text-[#CCFF00] transition-colors"
                  data-testid={`footer-link-${i.l.toLowerCase()}`}
                >
                  {i.l}
                </a>
              </li>
            ))}
          </ul>
        </div>

        <div className="md:col-span-4">
          <p className="text-[10px] uppercase tracking-[0.25em] text-zinc-500 mb-4">
            Suivre
          </p>
          <div className="flex gap-3">
            {[
              { Icon: Instagram, name: "instagram", href: "https://www.instagram.com/jeremy_aymes/", label: "Instagram @jeremy_aymes" },
            ].map(({ Icon, name, href, label }) => (
              <a
                key={name}
                href={href}
                target="_blank"
                rel="noopener noreferrer"
                aria-label={label}
                title={label}
                data-testid={`social-${name}`}
                className="w-11 h-11 grid place-items-center border border-white/10 hover:border-[#CCFF00]/60 hover:bg-[#CCFF00]/5 transition-colors"
              >
                <Icon className="w-4 h-4 text-zinc-400 hover:text-[#CCFF00] transition-colors" strokeWidth={1.5} />
              </a>
            ))}
          </div>
          <p className="mt-8 text-xs text-zinc-600">
            Micro-entreprise — SIRET sur demande.
          </p>
        </div>
      </div>

      <div className="max-w-7xl mx-auto mt-12 pt-8 border-t border-white/5 flex flex-col md:flex-row items-center justify-between gap-4">
        <p className="text-xs text-zinc-600">
          © {year} Aymes Goalkeeper Coaching. Tous droits réservés.
        </p>
        <p className="text-[10px] uppercase tracking-[0.25em] text-zinc-600">
          Conçu pour la performance.
        </p>
      </div>
    </footer>
  );
}
